import React from 'react';
import classes from './Footer.module.css';

const footer = (props) => {
  const footerLinkClicked = (linkPath) => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    props.handleNavLinkClick(linkPath);
  };
  return (
    <div style={{ display: !props.show ? 'none' : 'block' }} className={classes.FooterContainer}>
      <p className={classes.CopyRight}> &copy; {new Date().getFullYear()} Strength-Based Family Systems, LLC</p>
      <div className={classes.TermsAndPrivacy}>
        <span className={classes.Link} onClick={() => footerLinkClicked('/privacy')}>
          Privacy Policy
        </span>
        <span className={classes.Dot}>·</span>
        <span className={classes.Link} onClick={() => footerLinkClicked('/terms')}>
          Terms and Conditions
        </span>
      </div>
    </div>
  );
};

export default footer;
